'use client'

import { useTranslations } from 'next-intl'

import { Card } from '@/entities/auth'
import { useRouter } from '@/shared/i18n'
import { Slot, useDialog } from '@/shared/lib'
import { AlertDialog } from '@/shared/ui'

import { ResetPasswordForm } from './reset-password-form'

const DIALOG = {
  RESET_PASSWORD_COMPLETED: 'RESET_PASSWORD_COMPLETED',
} as const

type ResetPasswordDialog = keyof typeof DIALOG

type Props = {
  certNum: string
}

export const ResetPassword = ({ certNum }: Props) => {
  const router = useRouter()
  const { isOpen, open, close } = useDialog<ResetPasswordDialog>()

  const t = useTranslations('reset_password')

  const closeDialog = (key: ResetPasswordDialog) => () => {
    close(key)
  }

  const handleResetPasswordSuccess = () => {
    open(DIALOG.RESET_PASSWORD_COMPLETED)
  }

  const handleResetPasswordCompleted = () => {
    close(DIALOG.RESET_PASSWORD_COMPLETED)

    router.push('/sign-in')
  }

  return (
    <>
      <Card>
        <Slot name="title">{t('title')}</Slot>
        <Slot name="description">{t('description')}</Slot>
        <Slot name="children">
          <ResetPasswordForm
            certNum={certNum}
            onSuccess={handleResetPasswordSuccess}
          />
        </Slot>
      </Card>
      <AlertDialog
        isOpen={isOpen(DIALOG.RESET_PASSWORD_COMPLETED)}
        onOpenChange={closeDialog(DIALOG.RESET_PASSWORD_COMPLETED)}
        title={t('dialog.password_changed.title')}
        content={t('dialog.password_changed.description')}
        confirmText={t('dialog.password_changed.button.confirm')}
        onConfirm={handleResetPasswordCompleted}
        preventOutsideClick
      />
    </>
  )
}
